export default __webpack_public_path__ + "static/media/news4.3d649bff.png";